import { getAppFromPath } from "@shared-utils/routing";
import { usePathname } from "next/navigation";

export const useAppFromPath = () => {
  const path = usePathname();
  return getAppFromPath(path);
};
